import Bb from '../../config/backbone'
import dispatcher from '../../dispatcher'

const Settings = Bb.Model.extend({
    defaults: {
        orientation: 'manual',//auto
        layout: 'horizontal', //vertical
        mode: 'dices', //or dices,
        playersModal: false,
        theme: 'default',
        route: 'board' // or stats
    },
    initialize(){
        Bb.Model.prototype.initialize.apply(this, arguments)
        this.listenTo(this, 'change', () => {
            dispatcher.emit('settings:changed')
        })
    },
    reset (p) {
        this.clear()
        this.set(Object.assign({}, this.defaults, p))
    }
})


export default Settings







// WEBPACK FOOTER //
// ./src/game/config/Settings.js